export const enum HttpStatus {
  OK = 200,
  Unauthorized = 401,
  Forbidden = 403,
  NotFound = 404,
  Conflict = 409,
  Locked = 423,
}
